$(document).ready(function(){

    $('.tab-menu li span').on('click', function() {
        var target = $(this).attr('data-rel');
    
        if ($(this).hasClass('active')) {
            // If the clicked tab is already active, deactivate it
            $(this).removeClass('active');
            $(".tab-box[id='"+target+"']").removeClass('active');
        } else {
            // Otherwise, activate the clicked tab and deactivate others
            $('.tab-menu li span').removeClass('active');
            $(this).addClass('active');
            $(".tab-box").removeClass('active');
            $(".tab-box[id='"+target+"']").addClass('active');
        }
    });

    $(".blog_filter").click(function(){
        $(".cdk_blog_filter").addClass("active");
        $(".cdk_overlay").addClass("active");
    });

    $(".blog_close_btn").click(function(){
        $(".cdk_blog_filter").removeClass("active");
        $(".cdk_overlay").removeClass("active");
      });
    

});

$(document).on("click", ".custom-sort-wrapper li", function () {
    var facetChange = $(this).attr("value");
    $(this).siblings('li').removeClass('selected');
    $(this).addClass('selected');
    // console.log(facetChange);
    $(this).parents(".custom-sort-by").find("select option[value='" +facetChange+ "']").attr('selected', 'selected');
    $(".custom-sort-by select").val(facetChange).change();
  });
  $(document).on('change', '.custom-sort-by select', function() {
    var sortBy = $(this).val();
    var pageURL = $(location).attr("href");
   // Find the index of "sort_by="
    var startIndex = pageURL.indexOf("sort_by=");
  
    if (startIndex !== -1) {
    var textAfterSortBy = pageURL.substring(startIndex + "sort_by=".length);
    var modifiedURL = pageURL.replace(textAfterSortBy, "");
   var newUrl = modifiedURL+sortBy+'&';
    // console.log("Modified URL: " + modifiedURL);
    }
    else if (document.URL.indexOf("search") > -1) { 
       var modifiedURL = pageURL;
      var newUrl = modifiedURL+'&sort_by='+sortBy+'&';
    }
    else {
       var modifiedURL = pageURL;
      var newUrl = modifiedURL+'?sort_by='+sortBy+'&';
    }
    // console.log('newUr::'+newUrl)
    $.ajax({
      type: 'GET',
      url: newUrl,
      data: "html",
      success: function(data) {
        history.pushState('data', '', newUrl);
        var productListing = $(data).find('#product-grid .collection__item');
        $('#product-grid:not(.template-search__results)').html(productListing);
        $('#product-grid.template-search__results .product-grid').html(productListing);
        // $(".collection .loading-overlay").hide();
      }
    });
   

  });

  $(document).ready(function(){
  const inputField = document.getElementById('inputField');
  const button1 = document.getElementById('cdk_serach_btn_1');
  const button2 = document.getElementById('cdk_serach_btn_2');

  inputField.addEventListener('keyup', () => {
      const inputValue = inputField.value.trim();
      if (inputValue.length > 0) {
          button2.style.display = 'inline-block'; // Show Button 2
          button1.style.display = 'none'; // Hide Button 1
      } else {
          button2.style.display = 'none'; // Hide Button 2
          button1.style.display = 'inline-block'; // Show Button 1
      }
  });

  $(document).on('click', '#cdk_serach_btn_2 a', function () {
    $('.search__button').trigger('click');
  });
  $(document).on('click', '.custom-sort-by label', function () {
    $(".custom-sort-by").toggleClass("active");
  });

  $(document).ready(function() {
    const $myDiv = $(".header__heading-logo");
    
    // Add a class
    $myDiv.addClass("cdk__logo__animation");
    
    // Optionally remove the class after a delay (for demonstration)
    setTimeout(() => {
      $myDiv.removeClass("cdk__logo__animation");
    }, 500); // Removes the class after 3 seconds
  });

});
